import logo from "./logo.svg";
import "./App.css";
import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from "./routes/AppRoutes";
import Maintenance from "../src/components/Maintenance";
function App() {
  return (
    <Router basename="/tmw">
      <AppRoutes />
    </Router>
  );
}

export default App;
